/**
 * Shared report-section counts (Login card, Landing page marketing
 * copy, help modals, tooltips). Single source of truth so copy drift
 * doesn't recur when the report structure changes.
 *
 * Sprint 5 client feedback 2026-07-08 (UI Ticket — Login section
 * counts) — Login/Landing card copy had drifted to "10-section" for
 * DD (the DD report actually renders 12 sections) and "7-section"
 * for SPA (correct). Centralising the counts here prevents future
 * drift: when a section is added or removed from the report, this
 * file updates in one place and every marketing surface follows.
 *
 * Keep in sync with the report generators:
 *   - DD: frontend/src/pages/ReportPage.tsx (built.push calls)
 *   - SPA: frontend/src/components/spa/spaSections.tsx (buildSpaSections)
 *   - Risk: frontend/src/pages/RiskReportPage.tsx (per-section renderers)
 */

/** Number of top-level sections the DD Report renders. */
export const DD_SECTION_COUNT = 12;

/** Number of top-level sections the SPA Report renders. */
export const SPA_SECTION_COUNT = 7;

/** Number of top-level sections the Risk Report renders. */
export const RISK_SECTION_COUNT = 15;
